import { useEffect, useState } from 'react';
import { getInitialTheme, applyTheme, type Theme } from '../lib/theme';

export function useTheme(): [Theme, (t: Theme) => void] {
  const [theme, setTheme] = useState<Theme>(() => getInitialTheme());
  useEffect(() => applyTheme(theme), [theme]);
  return [theme, setTheme];
}
